var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{style:(_vm.styleVal),attrs:{"id":!_vm.flex ? 'ax-card' : 'ax-card-flex',"color":_vm.background,"width":_vm.width,"height":_vm.height,"min-width":_vm.width,"min-height":_vm.height}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }